
import { useEffect, useState } from "react"
import { ChartstwitsRepository } from "../../repository/ChartstwitsRepository";
import { useNavigate } from 'react-router-dom';

export function CatalystModel(){
    const apiModel = ChartstwitsRepository();
    const navigate = useNavigate();

    const [lstCatalyst,setCatalyst] = useState([{
        Ticker: '',
        Count: 0,
    }])

    const viewCatalyst = async () =>{
        debugger;
        setCatalyst([]);
        const responseData:any = await apiModel.viewCatalyst();
        debugger;
        if (responseData.length > 0) {
            debugger;
            setCatalyst(responseData);
        }
    }

    useEffect(()=>{
        viewCatalyst();
    },[])

    
const back = () =>{
    debugger;
    navigate(`/dashboard`);
  }
  

    return{lstCatalyst,back}
}